import { MagicConfigMixin } from '@gig/magic-common';
import { __extends, __decorate, __metadata } from 'tslib';
import { Prop, Component, Mixins } from 'vue-property-decorator';

/**
 * Component used as an decorative box in which content goes.
 */
var BoxComponent = /** @class */ (function (_super) {
    __extends(BoxComponent, _super);
    function BoxComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(BoxComponent.prototype, "elevationClass", {
        get: function () {
            if (this.elevation <= 0 || this.elevation > 5) {
                return '';
            }
            return "box--elevation-" + this.elevation;
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        Prop({
            default: 0,
            type: Number,
        }),
        __metadata("design:type", Number)
    ], BoxComponent.prototype, "elevation", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], BoxComponent.prototype, "noBottomPadding", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], BoxComponent.prototype, "addBottomMargin", void 0);
    BoxComponent = __decorate([
        Component({
            name: 'ui-box',
        })
    ], BoxComponent);
    return BoxComponent;
}(Mixins(MagicConfigMixin)));

export default BoxComponent;
